const REFERENCE_FRAME_MS = 1000 / 60;
const REFERENCE_WIDTH = 420;
const MIN_MOTION_SCALE = 0.68;

export const getFrameDelta = (elapsedMs: number) =>
  Math.min(2, Math.max(0.25, elapsedMs / REFERENCE_FRAME_MS));

export const getAtomMotionProfile = (width: number) => {
  const viewportScale = Math.min(
    1,
    Math.max(MIN_MOTION_SCALE, width / REFERENCE_WIDTH),
  );

  return {
    initialVelocity: 1.2 * viewportScale,
    randomAcceleration: 0.5 * viewportScale,
    maxVelocity: 1.6 * viewportScale,
  };
};

export const limitVelocity = (
  vx: number,
  vy: number,
  maxVelocity: number,
) => {
  const speed = Math.hypot(vx, vy);
  if (speed <= maxVelocity || speed === 0) return { vx, vy };

  const ratio = maxVelocity / speed;
  return { vx: vx * ratio, vy: vy * ratio };
};
